import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-user-account-dialog',
  templateUrl: './delete-user-account-dialog.component.html',
  styleUrls: ['./delete-user-account-dialog.component.scss']
})
export class DeleteUserAccountDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}
